import {
  createRecipeContext,
  type HTMLChakraProps,
  type RecipeVariantProps,
} from '@chakra-ui/react'

import { pageContainerRecipe } from '@/theme/recipes/page-container.recipe'

type PageContainerProps = HTMLChakraProps<'main'> & RecipeVariantProps<typeof pageContainerRecipe>

const { withContext } = createRecipeContext({ recipe: pageContainerRecipe })

export const PageContainer = withContext<HTMLElement, PageContainerProps>('main')
